<template>
  <div>
    <!-- Mobile Overlay Backdrop -->
    <div v-if="showFullCard" class="drawer-overlay" @click="closeDrawer"></div>
    
    <div class="trade-card"
         :class="{ 'drawer-expanded': showFullCard, 'drawer-collapsed': !showFullCard }">
      
      <!-- Close Button -->
      <button v-if="showFullCard" class="close-btn " :class="{ 'mobile-hidden': !showFullCard  }" @click="closeDrawer">
        X
      </button>

    <!-- Card Header Section (like PredictionCard) -->
    <div class="trade-card-title mobile-hidden" >
      <h3>Мой прогноз</h3>
    </div>
    

    <div class="card-header" :class="{ 'mobile-hidden': !showFullCard }">
      <div class="card-title-section">
        <h3 class="card-title">{{ prediction.title }}</h3>
      </div>
      <div class="prediction-percentage-label">{{ prediction.percentage }}% - текущий прогноз</div>
    </div>
    
    <div class="mobile-title-actions-row" :class="{ 'mobile-hidden': !showFullCard }">
      <div class="trade-card-title-small">
        <h3>Мой прогноз</h3>
      </div>
      <div class="card-actions-small">
        <button
          class="action-btn-small yes"
          :class="{ 'pressed': selectedChoice === 'yes' }"
          @click="selectChoice('yes')"
        > Да
        </button>
        <button
          class="action-btn-small no"
          :class="{ 'pressed': selectedChoice === 'no' }"
          @click="selectChoice('no')"
        >
          Нет
        </button>
      </div>
    </div>

    <!-- Trade Card Title -->
    <div class="card-actions" :class="{'mobile-hidden': showFullCard}">
      <button
        class="action-btn yes"
        :class="{ 'pressed': selectedChoice === 'yes' }"
        @click="selectChoice('yes')"
      > Да
      </button>
      <button
        class="action-btn no"
        :class="{ 'pressed': selectedChoice === 'no' }"
        @click="selectChoice('no')"
      >
        Нет
      </button>
    </div>
    <div class="form-field-section" :class="{ 'mobile-hidden': !showFullCard }">
      <div class="form-field-container">
        <div class="form-field-label">Ставка</div>
        <div class="trade-amount-value">
          <button class="amount-control-btn" @click="subtractAmount(500)">−</button>
          <input
            class="amount-input"
            :value="renderedAmount"
            @focusin="onIntputFocusIn"
            @focusout="onIntputFocusOut"
            @change="onAmountEdit"
            @keyup.enter="(event) => event.target.blur()"
            min="0"
            step="0.01"
            placeholder="500"
          />
          <button class="amount-control-btn" @click="addAmount(500)">+</button>
        </div>
      </div>
    </div>

    <div class="form-field-section" :class="{ 'mobile-hidden': !showFullCard }">
      <div class="form-field-container">
        <div class="form-field-label">Выиграю: </div>
        <div class="form-field-label" id="winDisplay">{{  winAmount }}</div>
      </div>
    </div>
    <button class="trade-btn" @click="executeTrade" :class="{ 'mobile-hidden': !showFullCard }">Разместить прогноз</button>
  </div>
</div>
  
  <!-- Success Popup -->
  <div v-if="showSuccessPopup" class="popup-overlay" @click="closePopup">
    <div class="popup-content" @click.stop>
      <div class="popup-emoji">🎉</div>
      <div class="popup-text">Прогноз размещен</div>
      <div class="popup-text">Следите за новостями на канале <a href="https://t.me/Forecast_M" target="_blanc">Рынки Предсказаний</a></div>
      <div class="salute-animation"></div>
      <button class="popup-close-btn" @click="closePopup">Закрыть</button>
    </div>
  </div>
</template>

<script>
import { onMounted, setTransitionHooks } from 'vue';
import { apiClient } from '../api/client';


const MINIMAL_AMOUNT = 500;

export default {
  name: 'TradeCard',
  props: {
    yesPrice: {
      type: String,
      default: '23¢'
    },
    noPrice: {
      type: String,
      default: '78¢'
    },
    prediction: {
      type: Object,
      default: () => ({
        id: 6,
        title: "Ethereum обгонит Bitcoin по рыночной капитализации",
        volume: "410k",
        participants: 3127,
        percentage: 34
      })
    },
    marketId: {
      type: [String, Number],
      default: null
    },
    preSelectedChoice: {
      type: String, 
      default: null
    }
  },
  emits: ['amount-change'],
  
  data() {
    return {
      activeTab: 'buy',
      selectedMarket: 'Market',
      doNotAddMoneyUnits: false,
      amount: MINIMAL_AMOUNT,
      // selectedChoice: this.prediction.possibleWinYes >= this.prediction.possibleWinNo ? "yes":"no",
      selectedChoice: this.preSelectedChoice,
      showFullCard: this.preSelectedChoice !== null,
      startY: 0,
      currentY: 0,
      isDragging: false,
      dragThreshold: 30,
      scrollY: 0,
      dragOffset: 0,
      isActivelyDragging: false,
      showSuccessPopup: false
    }
  },
  computed: {
    renderedAmount() {
      if (this.doNotAddMoneyUnits) { return this.amount }
      else {
        return this.amount.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' p.'
      }
        
    },
    formattedPossibleWinYes() {
      if (this.prediction && this.prediction.possibleWinYes !== undefined && this.prediction.possibleWinYes !== null) {
        // Convert to number and format to 2 decimal places with thousands separator
        const num = parseFloat(this.prediction.possibleWinYes);
        if (!isNaN(num)) {
          return num.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits:0 });
        }
        return this.prediction.possibleWinYes; // return original if not a valid number
      }
      return '';
    },
    formattedPossibleWinNo() {
      if (this.prediction && this.prediction.possibleWinNo !== undefined && this.prediction.possibleWinNo !== null) {
        // Convert to number and format to 2 decimal places with thousands separator
        const num = parseFloat(this.prediction.possibleWinNo);
        if (!isNaN(num)) {
          return num.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }
        return this.prediction.possibleWinNo; // return original if not a valid number
      }
      return '';
    },

    winAmount() { 
      if (this.selectedChoice === "yes") return this.formattedPossibleWinYes + " р.";
      if (this.selectedChoice === "no") return this.formattedPossibleWinNo+ " р.";
      return "<выберите исход>";
      
    }
  },
  watch: {
    showFullCard(newVal) {
      if (window.innerWidth <= 1024) {
        if (newVal) {
          this.disableBodyScroll()
        } else {
          this.enableBodyScroll()
        }
      }
    }
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab
    },
    toggleMarketDropdown() {
      // In a real implementation, you would show a dropdown menu
      console.log('Toggle market dropdown')
    },
    selectChoice(choice) {
      this.selectedChoice = choice
      this.showFullCard = true
      this.$emit('amount-change', this.amount);
      // Highlight the selected choice visually if needed
    },
    addAmount(value) {
      this.amount += value
      this.$emit('amount-change', this.amount)
    },
    onIntputFocusIn() { 
        this.doNotAddMoneyUnits = true;
    },
    onIntputFocusOut() {
        this.doNotAddMoneyUnits = false;
    },
    onAmountEdit(event) {
      const value = parseFloat(event.target.value.replace(/[^0-9]/g, ''))
      if (!isNaN(value)) {
        this.amount = value>MINIMAL_AMOUNT ? value :MINIMAL_AMOUNT
        this.$emit('amount-change', this.amount)
      }
      
    },
    subtractAmount(value) {
      if (this.amount > MINIMAL_AMOUNT) {
        this.amount = Math.max(0, this.amount - value)
        this.$emit('amount-change', this.amount)
      } else {
        this.amount = MINIMAL_AMOUNT
        this.$emit('amount-change', this.amount)
      }

    },
    setMaxAmount() {
      // In a real implementation, you would set the amount to the user's max available balance
      this.amount = 1000 // Placeholder for max amount
      this.$emit('amount-change', this.amount)
    },
    executeTrade() {
      // Execute trade logic would go here
      console.log(`Executing ${this.activeTab} trade for ${this.selectedChoice} with amount $${this.amount}`);
      
      // Create the request body
      const requestBody = {
        marketId: this.marketId,
        userId: 1,
        predictionOutcome: this.selectedChoice,
        totalPaid: this.amount
      };
      
      // Make POST request to /order/create
      apiClient.post('/order/create', requestBody)
        .then(() => {
          console.log('Order created successfully:');

          // Show success popup
          this.showSuccessPopup = true;
          
          // Create salute animation after popup is shown
          this.$nextTick(() => {
            setTimeout(() => {
              this.createSaluteAnimation();
            }, 100); // Small delay to ensure popup is visible
          });
        })
        .catch(error => {
          console.error('Error creating order:', error);
          // Handle error (e.g., show error message)
        });
    },
    closePopup() {
      this.showSuccessPopup = false;
      this.showFullCard = false;
      this.amount = MINIMAL_AMOUNT;
      this.selectedChoice = null;
      this.$emit('amount-change', this.amount);
    },
    
    // Function to create salute animation particles
    createSaluteAnimation() {
      // Wait for the popup to be rendered before creating particles
      this.$nextTick(() => {
        const popupContent = document.querySelector('.popup-content');
        if (!popupContent) return;
        
        // Clear any existing particles
        const existingParticles = popupContent.querySelectorAll('.salute-particle');
        existingParticles.forEach(p => p.remove());
        
        // Create multiple particles for the salute effect
        for (let i = 0; i < 30; i++) {
          setTimeout(() => {
            this.createParticle(popupContent);
          }, i * 50); // Stagger the particle creation
        }
      });
    },
    
    // Function to create a single particle
    createParticle(container) {
      const particle = document.createElement('div');
      particle.classList.add('salute-particle');
      
      // Random color for the particle
      const colors = ['#10B981', '#3B82F6', '#8B5CF6', '#EC4899', '#F59E0B', '#EF4444'];
      const randomColor = colors[Math.floor(Math.random() * colors.length)];
      particle.style.backgroundColor = randomColor;
      
      // Random starting position (around the emoji area)
      const startX = container.clientWidth / 2;
      const startY = 100; // Around the emoji position
      
      particle.style.left = `${startX}px`;
      particle.style.top = `${startY}px`;
      
      // Random trajectory
      const angle = Math.random() * Math.PI * 2; // Random angle
      const distance = 50 + Math.random() * 100; // Random distance
      const tx = Math.cos(angle) * distance;
      const ty = Math.sin(angle) * distance;
      
      // Set CSS variables for animation
      particle.style.setProperty('--tx', `${tx}px`);
      particle.style.setProperty('--ty', `${ty}px`);
      
      container.appendChild(particle);
      
      // Remove particle after animation completes
      setTimeout(() => {
        particle.remove();
      }, 1500);
    },
    closeDrawer() {
      this.showFullCard = false
      this.selectedChoice = null
    },
    
    disableBodyScroll() {
      // Save current scroll position
      this.scrollY = window.scrollY
      // Prevent body from scrolling
      document.body.style.position = 'fixed'
      document.body.style.top = `-${this.scrollY}px`
      document.body.style.width = '100%'
      document.body.style.overflow = 'hidden'
    },
    enableBodyScroll() {
      // Restore body scrolling
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      document.body.style.overflow = ''
      // Restore scroll position
      if (this.scrollY) {
        window.scrollTo(0, this.scrollY)
      }
    }
  }
}
</script>

<style scoped>
.trade-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px 0 rgba(24, 35, 52, 0.06);
  /* width: 370px; */
  padding: 20px 16px 24px 16px;
  margin: 0;
  box-sizing: border-box;
}

.trade-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.trade-tab-group {
  display: flex;
  align-items: center;
  gap: 16px;
}

.trade-tab {
  font-size: 20px;
  font-weight: 600;
  color: #20242a;
  padding-bottom: 2px;
  cursor: pointer;
  transition: color 0.15s;
}

.trade-tab.disabled {
  color: #babac0;
  font-weight: 400;
  cursor: default;
}

.trade-market {
  font-size: 17px;
  color: #20242a;
  font-weight: 500;
  cursor: pointer;
  background: transparent;
  border: none;
  outline: none;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 5px;
}

.trade-underline {
  margin-top: 5px;
  height: 3px;
  width: 38px;
  background: #20242a;
  border-radius: 2px;
  margin-bottom: 16px;
}

.trade-card-title {
  margin-bottom: 16px;
}

.trade-card-title h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.card-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 26px;
}

.card-title{
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.action-btn.pressed {
  background: #1563fc;
  border-color: #1563fc;
  color: #fff;
  transform: scale(1.1);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-btn.yes.pressed {
  background: #10b981;
  border-color: #10b981;
}

.action-btn.no.pressed {
  background: #ef4444;
  border-color: #ef4444;
}

.form-field-section {
  display: flex;
  align-items: center;
  justify-content: left;
  margin-bottom: 16px;
}

.form-field-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.form-field-label {
  font-size: 20px;
  font-weight: 500;
  color: #20242a;
  text-align: left;
  /* align-self: flex-start; */
}

.trade-amount-value {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 42px;
  font-weight: 600;
  color: #babac0;
  letter-spacing: 0.5px;
  max-width: 300px;
}

.amount-control-btn {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e7e7ea;
  background: #fafbfc;
  color: #20242a;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  outline: none;
}

.amount-control-btn:hover {
  background: #f0f1f2;
  border-color: #d1d5db;
}

.amount-control-btn:active {
  transform: scale(0.95);
}


.amount-input {
  flex: 1;
  /* background: #ededed; */
  border: 1px solid #e7e7ea;
  outline: none;
  font-size: 32px;
  font-weight: 600;
  color: #20242a;
  text-align: center;
  letter-spacing: 0.5px;
  min-width: 0;
}

.amount-input::placeholder {
  color: #babac0;
}

.amount-input::-webkit-outer-spin-button,
.amount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.amount-input[type=number] {
  -moz-appearance: textfield;
}

.trade-amount-buttons {
  display: flex;
  gap: 12px;
  margin-bottom: 28px;
}

.amount-btn {
  font-size: 1rem;
  font-weight: 500;
  padding: 7px 17px;
  border-radius: 9px;
  background: #fafbfc;
  color: #20242a;
  border: 1px solid #e7e7ea;
  outline: none;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.amount-btn:last-child {
  padding: 7px 19px;
}

.trade-btn {
  width: 100%;
  background: #1563fc;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: 9px;
  padding: 15px 0 12px 0;
  border: none;
  outline: none;
  cursor: pointer;
  box-shadow: 0 3px 0 0 #0842ac;
  margin-bottom: 0;
  margin-top: 6px;
  transition: background 0.15s;
}

/* Card header - hidden on desktop, shown in mobile drawer */
.card-header {
  display: none;

}

/* Mobile title-actions row - hidden on desktop */
.mobile-title-actions-row {
  display: none;
  margin-top: 1.5rem;
}

/* Desktop card-actions */
.desktop-only {
  display: block;
}

/* Small action buttons styling */
.trade-card-title-small h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.card-actions-small {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.action-btn-small {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
  color: #1f2937;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 60px;
}

.action-btn-small.yes {
  color: #10b981;
  background-color: #ecfdf5;
}

.action-btn-small.no {
  color: #ef4444;
  background-color: #fef2f2;
}

.action-btn-small.pressed {

  transform: scale(1.15);
}

.action-btn-small.yes.pressed {
  background: #10b981;
  border-color: #10b981;
  color: #fff;
}

.action-btn-small.no.pressed {
  background: #ef4444;
  border-color: #ef4444;
  color: #fff;
}

/* Drawer handle styles */

/* Close button styles */
.close-btn {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: #6b7280;
  transition: color 0.2s ease;
  z-index: 10;
  display: flex;
  align-items: right;
  justify-content: right;
  border-radius: 50%;
}

.close-btn:hover {
  color: #374151;
  background-color: rgba(0, 0, 0, 0.05);
}

.close-btn svg {
  width: 20px;
  height: 20px;
}

/* Overlay backdrop for mobile drawer */
.drawer-overlay {
  display: none;
}

/* Hide close button on desktop */
@media (min-width: 1025px) {
  .close-btn {
    display: none !important;
  }
}


/* Mobile drawer styles */
@media (max-width: 1024px) {
  .drawer-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(2px);
    z-index: 999;
    animation: fadeIn 0.3s ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .mobile-hidden {
    display: none !important;
  }

  .mobile-drawer-hidden {
    display: none !important;
  }

  /* Hide desktop card-actions on mobile */
  .desktop-only {
    display: none !important;
  }

  /* Show mobile title-actions row */
  .mobile-title-actions-row {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
    opacity: 0;
    transform: translateY(-10px);
    transition: all 0.3s ease;
  }

  .trade-card.drawer-expanded .mobile-title-actions-row {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.05s;
  }


  .trade-card {
    width: 100vw;
    max-width: 100vw;
    margin: 0;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.15);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    min-width: 320px;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    overflow: hidden;
    z-index: 1000;
  }

  .trade-card.drawer-collapsed {
    padding: 8px 16px 16px 16px;
    height: auto;
    max-height: 120px;
  }

  .trade-card.drawer-expanded {
    padding: 8px 16px 24px 16px;
    height: auto;
    max-height: 600px;
  }

  .trade-card.drawer-collapsed .mobile-hidden {
    display: none !important;
  }

  .card-header {
    display: block;
    margin-bottom: 16px;
    opacity: 0;
    transform: translateY(-10px);
    transition: all 0.3s ease;
  }

  .trade-card.drawer-expanded .card-header {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.1s;
  }

  .trade-card.drawer-expanded .trade-card-title {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.05s;
  }

  .trade-card-title {
    opacity: 0;
    transform: translateY(-10px);
    transition: all 0.3s ease;
  }

  .trade-card.drawer-expanded .card-actions {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.2s;
  }

  .trade-card.drawer-expanded {
    display: block !important;
  }
  
  .trade-card-header {
    margin-bottom: 8px;
    opacity: 0;
    transform: translateY(-10px);
    transition: all 0.3s ease;
  }

  .trade-card.drawer-expanded .trade-card-header {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.1s;
  }
  
  .trade-tab {
    font-size: 16px;
  }
  
  .trade-market {
    font-size: 14px;
  }
  
  .trade-underline {
    margin-top: 4px;
    margin-bottom: 12px;
    opacity: 0;
    transform: translateY(-10px);
    transition: all 0.3s ease;
  }

  .trade-card.drawer-expanded .trade-underline {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.2s;
  }
  
  .card-actions {
    gap: 8px;
    margin-bottom: 16px;
    opacity: 1;
    transform: translateY(0);
    transition: all 0.3s ease;
  }

  .trade-card.drawer-collapsed .card-actions {
    opacity: 1;
    transform: translateY(0);
  }
  
  .action-btn {
    padding: 14px 0;
    font-size: 16px;
    min-height: 48px;
    transition: all 0.2s ease;
    flex: 1;
  }

  .action-btn.pressed {
     transform: scale(1); 
  }

  /* Mobile drawer expanded: selected button wider, non-selected narrower */
  .trade-card.drawer-expanded .action-btn.pressed {
    flex: 1.2;
  }

  .trade-card.drawer-expanded .action-btn:not(.pressed) {
    flex: 0.8;
  }

  .action-btn.yes.pressed {
    background: #10b981;
    border-color: #10b981;
    color: #fff;
  }

  .action-btn.no.pressed {
    background: #ef4444;
    border-color: #ef4444;
    color: #fff;
  }
  
  .form-field-section,
  .trade-amount-buttons,
  .trade-btn {
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease;
  }

  .trade-card.drawer-expanded .form-field-section {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.3s;
    margin-bottom: 12px;
  }

  .trade-card.drawer-expanded .trade-amount-buttons {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.4s;
    gap: 8px;
    margin-bottom: 16px;
  }

  .trade-card.drawer-expanded .trade-btn {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.5s;
    font-size: 16px;
    padding: 14px 0 12px 0;
  }
  
  .form-field-label {
    font-size: 16px;
  }
  
  .trade-amount-value {
    font-size: 24px;
    gap: 8px;
  }

  .amount-control-btn {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }

  .amount-input {
    font-size: 20px;
    max-width:200px;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
  }
  
  .amount-btn {
    font-size: 14px;
    padding: 6px 10px;
    flex: 1;
  }
}

/* Success Popup Styles */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease-out;
}

.popup-content {
  background: white;
  border-radius: 16px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  max-width: 400px;
 width: 80%;
  position: relative;
  animation: popUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.popup-emoji {
  font-size: 60px;
  margin-bottom: 15px;
 animation: bounce 0.6s ease infinite alternate;
}

.popup-text {
  font-size: 22px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 25px;
}

.salute-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
}

/* Enhanced Salute Animation */
.popup-content {
 background: white;
 border-radius: 16px;
 padding: 30px;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 80%;
  position: relative;
  animation: popUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: visible;
}

.popup-emoji {
  font-size: 60px;
 margin-bottom: 15px;
 animation: bounce 0.6s ease infinite alternate;
  position: relative;
  z-index: 2;
}

.popup-text {
  font-size: 22px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 25px;
 position: relative;
  z-index: 2;
}

.salute-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
  border-radius: 16px;
}

.salute-particle {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  animation: particleAnimation 1.5s ease-out forwards;
}

.popup-close-btn {
  background: #1563fc;
  color: white;
 border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
  position: relative;
  z-index: 2;
}

.popup-close-btn:hover {
 background: #0842ac;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes popUp {
  0% {
    opacity: 0;
    transform: scale(0.7) translateY(20px);
  }
  70% {
    transform: scale(1.05) translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
 }
}

@keyframes particleAnimation {
  0% {
    transform: translate(0, 0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(var(--tx), var(--ty)) scale(0);
    opacity: 0;
  }
}
</style>